/**
 * @generated SignedSource<<e892fa33c12998ca0e87bbb66d4074a1>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ExpireDatePickerEditMutation$variables = {
  batchId: string;
  date: string;
  productId: string;
};
export type ExpireDatePickerEditMutation$data = {
  readonly storeProduct: {
    readonly expireBatch: {
      readonly changeDate: {
        readonly actions: ReadonlyArray<{
          readonly id: string;
          readonly startAtDate: {
            readonly isoString: string;
          };
        }>;
        readonly id: string;
        readonly product: {
          readonly hasExpiredExpireDates: boolean;
          readonly hasPendingExpireDateActions: boolean;
          readonly id: string;
        } | null;
        readonly " $fragmentSpreads": FragmentRefs<"ProductExpireBatch_ProductExpireBatch" | "ProductExpireDateListItem_StoreProductExpireBatch">;
      } | null;
    } | null;
  } | null;
};
export type ExpireDatePickerEditMutation = {
  response: ExpireDatePickerEditMutation$data;
  variables: ExpireDatePickerEditMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "batchId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "date"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "productId"
},
v3 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "productId"
  }
],
v4 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "batchId"
  }
],
v5 = [
  {
    "kind": "Variable",
    "name": "date",
    "variableName": "date"
  }
],
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hasPendingExpireDateActions",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hasExpiredExpireDates",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isoString",
  "storageKey": null
},
v10 = [
  (v9/*: any*/)
],
v11 = {
  "alias": null,
  "args": null,
  "concreteType": "StoreZonedDate",
  "kind": "LinkedField",
  "name": "expireAtDate",
  "plural": false,
  "selections": (v10/*: any*/),
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "label",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "concreteType": "StoreZonedDate",
  "kind": "LinkedField",
  "name": "startAtDate",
  "plural": false,
  "selections": [
    (v9/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "timezone",
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "ExpireDatePickerEditMutation",
    "selections": [
      {
        "alias": null,
        "args": (v3/*: any*/),
        "concreteType": "StoreProductMutation",
        "kind": "LinkedField",
        "name": "storeProduct",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v4/*: any*/),
            "concreteType": "StoreProductExpireBatchMutation",
            "kind": "LinkedField",
            "name": "expireBatch",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": (v5/*: any*/),
                "concreteType": "StoreProductExpireBatch",
                "kind": "LinkedField",
                "name": "changeDate",
                "plural": false,
                "selections": [
                  (v6/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "StoreProduct",
                    "kind": "LinkedField",
                    "name": "product",
                    "plural": false,
                    "selections": [
                      (v6/*: any*/),
                      (v7/*: any*/),
                      (v8/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "ProductExpireDateListItem_StoreProductExpireBatch"
                  },
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "ProductExpireBatch_ProductExpireBatch"
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "StoreProductExpireBatchAction",
                    "kind": "LinkedField",
                    "name": "actions",
                    "plural": true,
                    "selections": [
                      (v6/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "StoreZonedDate",
                        "kind": "LinkedField",
                        "name": "startAtDate",
                        "plural": false,
                        "selections": (v10/*: any*/),
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "ExpireDatePickerEditMutation",
    "selections": [
      {
        "alias": null,
        "args": (v3/*: any*/),
        "concreteType": "StoreProductMutation",
        "kind": "LinkedField",
        "name": "storeProduct",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v4/*: any*/),
            "concreteType": "StoreProductExpireBatchMutation",
            "kind": "LinkedField",
            "name": "expireBatch",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": (v5/*: any*/),
                "concreteType": "StoreProductExpireBatch",
                "kind": "LinkedField",
                "name": "changeDate",
                "plural": false,
                "selections": [
                  (v6/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "StoreProduct",
                    "kind": "LinkedField",
                    "name": "product",
                    "plural": false,
                    "selections": [
                      (v6/*: any*/),
                      (v7/*: any*/),
                      (v8/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "StoreProductExpireBatch",
                        "kind": "LinkedField",
                        "name": "activeExpireBatches",
                        "plural": true,
                        "selections": [
                          (v6/*: any*/),
                          (v11/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "name",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "partNumber",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "imageUrl",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "StoreProductExpireBatchAction",
                    "kind": "LinkedField",
                    "name": "activeAction",
                    "plural": false,
                    "selections": [
                      (v6/*: any*/),
                      (v12/*: any*/),
                      (v13/*: any*/),
                      (v14/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v11/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "StoreProductExpireBatchAction",
                    "kind": "LinkedField",
                    "name": "actions",
                    "plural": true,
                    "selections": [
                      (v6/*: any*/),
                      (v13/*: any*/),
                      (v12/*: any*/),
                      (v14/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v13/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "StoreZonedDate",
                    "kind": "LinkedField",
                    "name": "deadlineAtDate",
                    "plural": false,
                    "selections": (v10/*: any*/),
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "30c6bb43a5d6878276335b4cbf4900c6",
    "id": null,
    "metadata": {},
    "name": "ExpireDatePickerEditMutation",
    "operationKind": "mutation",
    "text": "mutation ExpireDatePickerEditMutation(\n  $productId: ID!\n  $batchId: ID!\n  $date: String!\n) {\n  storeProduct(id: $productId) {\n    expireBatch(id: $batchId) {\n      changeDate(date: $date) {\n        id\n        product {\n          id\n          hasPendingExpireDateActions\n          hasExpiredExpireDates\n        }\n        ...ProductExpireDateListItem_StoreProductExpireBatch\n        ...ProductExpireBatch_ProductExpireBatch\n        actions {\n          id\n          startAtDate {\n            isoString\n          }\n        }\n      }\n    }\n  }\n}\n\nfragment ProductExpireBatchActionList_productExpireBatch on StoreProductExpireBatch {\n  id\n  activeAction {\n    id\n  }\n  actions {\n    id\n    status\n    ...ProductExpireBatchAction_StoreProductExpireBatchAction\n  }\n  product {\n    id\n  }\n}\n\nfragment ProductExpireBatchAction_StoreProductExpireBatchAction on StoreProductExpireBatchAction {\n  id\n  label\n  status\n  startAtDate {\n    isoString\n    timezone\n    ...StoreRelativeZonedDate_StoreZonedDate\n  }\n}\n\nfragment ProductExpireBatchDatePicker_StoreProduct on StoreProduct {\n  activeExpireBatches {\n    id\n    expireAtDate {\n      isoString\n    }\n  }\n}\n\nfragment ProductExpireBatchListItemAction_StoreProductExpireBatchAction on StoreProductExpireBatchAction {\n  id\n  label\n  status\n  startAtDate {\n    isoString\n    timezone\n    ...StoreRelativeZonedDate_StoreZonedDate\n  }\n}\n\nfragment ProductExpireBatchProductPreview_StoreProduct on StoreProduct {\n  id\n  name\n  partNumber\n  imageUrl\n}\n\nfragment ProductExpireBatchStatusFooter_productExpireBatch on StoreProductExpireBatch {\n  status\n  id\n  product {\n    id\n  }\n  deadlineAtDate {\n    isoString\n  }\n}\n\nfragment ProductExpireBatch_ProductExpireBatch on StoreProductExpireBatch {\n  id\n  expireAtDate {\n    isoString\n  }\n  product {\n    id\n    ...ProductExpireBatchDatePicker_StoreProduct\n    ...ProductExpireBatchProductPreview_StoreProduct\n  }\n  ...ProductExpireBatchActionList_productExpireBatch\n  ...ProductExpireBatchStatusFooter_productExpireBatch\n}\n\nfragment ProductExpireDateListItem_StoreProductExpireBatch on StoreProductExpireBatch {\n  activeAction {\n    ...ProductExpireBatchListItemAction_StoreProductExpireBatchAction\n    id\n  }\n  expireAtDate {\n    isoString\n  }\n}\n\nfragment StoreRelativeZonedDate_StoreZonedDate on StoreZonedDate {\n  isoString\n  timezone\n}\n"
  }
};
})();

(node as any).hash = "8e5ef051eea3606f3b259972e3518d87";

export default node;
